<template>
  <div>
		<modal name="modalCounsel" classes="main-modal" :adaptive="true" :width="width" :height="height"
    @before-open="beforeOpen"
    @opened="opened"
    @before-close="onBeforeClose">
      <div class="modal-header">
        <h2 class="modal-header-title">1:1 문의</h2>
        <button @click="closeModal()"><img src="@/assets/icons/icon-close-modal.svg" alt="" /></button>
      </div>

      <div class="modal-body">
        <div class="chat-body">

          <template v-for="(chat, index) in chatList">

            <ChatBubble
              v-bind:key="`chat-bubble-${index}`"
              :me="chat.regrId == getLoginUserInfo.usrSeq"
              :chatSeq="chat.chatSeq"
              :regrId="chat.regrId"
              :usrNm="chat.usrNm"
              :time="chat.regTime"
              :chat="chat.chatCont"
              :usrSeq = getLoginUserInfo.usrSeq
            />        

            <ChatDate v-bind:key="`chat-date-${index}`" :chatDate="chat.regDay" v-if="isChageDate(index)" />

          </template>

        </div>
        <div class="chat-input">
          <BaseBtn class="send">
            <img src="@/assets/icons/send-off.svg" alt="" @click="insertChat">
          </BaseBtn>
          <input type="text" placeholder="메세지를 입력하세요." v-model="form.chatCont" @keyup.enter="insertChat" />
        </div>       
			</div>
    </modal>
  </div>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue';
import ChatBubble from '@/components/community/ChatBubble.vue';
import ChatDate from '@/components/community/ChatDate.vue';
import Const from '@/const';

export default {
	name: 'WhiteLabelModalCounsel',
  components: {
    BaseBtn,
    ChatBubble,
    ChatDate,
  },
  computed: {
    getLoginUserInfo: function(){
      let loginInfo = window.$store.getters['Login/getLoginUserInfo'];
      return loginInfo;
    },
    resultMsg: function(){
      return window.$store.getters['SocketMsg/getMessage'];
    },
  },
  watch: {
    resultMsg:{
      handler(res){
        if (res.apiCode == Const.MSG_API_TYPE.USRCOUNSEL){
          //1:1 문의 답변 갱신
          this.search();
          return;
        }else if (res.apiCode == Const.MSG_API_TYPE.USRCOUNSELDEL){
          //1:1 문의 삭제 갱신
          this.chatList = [];
          return;
        }
      },
      deep:true
    },
  },
	data() {
		return {
			chatList: [],
      form: {
        chatCont : ''
      },
      interval : null,
		};
	},
	created() {
    if (window.innerWidth > 1200) {
      this.width = 1000;
      this.height = 600;
    } else {
      this.width = '100%';
      this.height = '100%';
    }
  },
  mounted() {

	},
  methods: {
    closeModal() {
      this.$modal.hide('modalCounsel');
    },
		showDetail(name, notice) {
			this.$modal.show(name, notice);
		},
    opened(){
    },
    beforeOpen(e){
      this.$emit('event:IsOpenCounsel', { isOpenCounsel: true});

      //리스트 초기화
      this.chatList = [];
      this.search();
    },
    async search() {
      
      const response = await window.$http.get('/api/usr-counsel/list', {params : {}})
            
      if (response.data && response.data.length > 0) {
        this.chatList = response.data
      }           
    },
    isChageDate(index) {
      if ( index <= 0 ) {
        return false
      }

      if ( index + 1 <= this.chatList.length - 1  
            && this.chatList[index + 1] && this.chatList[index] 
            && this.chatList[index + 1].regDay != this.chatList[index].regDay ) {
              return true
      }

      return false
    },
    insertChat() {
      if (this.form.chatCont === '') {
        return
      }

      if (this.form.chatCont.length > 140) {
        this.$alert.alert('140자를 초과 입력하실 수 없습니다.', '알림')
        return
      }      

      this.$http
        .post('/api/usr-counsel/insert',
            this.form)
        .then(() => {
          this.form.chatCont = ''
          this.search()
        })
    },
    onBeforeClose(){
      this.$emit('event:IsOpenCounsel', { isOpenCounsel: false});
    }, 
    
  },
};
</script>

<style lang="scss" scoped>

.chat-body {
  position: relative;
  /* flex: 1 1 auto; */
  /* display: grid; */
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
  padding: 20px 20px 20px 20px;
  height: calc(100% - 60px);
  overflow-y: scroll;
  border: 1px solid #bbb;
  @media (max-width: $mobile) {
    padding-top: 0;
    /* padding-bottom: 50px; */
    /* background-color: red; */
  }
}
.chat-input {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* flex: 0 0 auto; */
  position: relative;
  height: 50px;
  border: none;
  input {
    width: 100%;
    height: 50px;
    padding-right: 50px;
    padding-left: 20px;
    border: 1px solid #bbb;
    border-top : none;
  }
  .send {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    z-index: 99;
  }
}

</style>